var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerIconBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.423 3.243c.172-.523.927-.525 1.102-.002l1 2.988 3.21-.009c.56-.001.796.702.343 1.026L10.486 9.1l1 2.988c.175.522-.435.958-.89.636l-2.602-1.842-2.592 1.855c-.453.324-1.065-.109-.893-.632l.984-2.993-2.602-1.841c-.455-.322-.223-1.026.338-1.028l3.21-.008.984-2.993z"
  })));
}
export default SvgMarkerIconBookmark;